// extracted by mini-css-extract-plugin
export default {"pageContainer":"Style_pageContainer__1u3Nj","cardContainer":"Style_cardContainer__Ypd8x","truncateTitle":"Style_truncateTitle__gTm4q","avatar":"Style_avatar__Kpajf"};